<div class="position-relative h-100">
  <video #videoEl class="story-video-tag" webkit-playsinline="" playsinline [controls]="false" [src]="videoId" [muted]="!isMuted"
    autoplay >
    <source [src]="videoId" type="video/mp4" />
    <source [src]="videoId" type="video/webm" />
    <source [src]="videoId" type="video/ogg" />
    <p>Video not supported</p>
  </video>
  <div class="position-absolute toast-center-center" *ngIf="!isVideoPlaying" >
    <img src="assets/themes/images/primary-loader.gif" width="50" height="50">
  </div>
  <div *ngIf="isVideoPlaying" class="position-absolute tag-position text-center" style="z-index: 5">
    <p *ngIf="typingText" class=" text-break fnt-size14px  paragraph text-white wrap-line">
      {{typingText}}
    </p>
    <div>
      <p *ngFor="let tagUser of tagUsers" class="mt-1">
        <span class="tag-chip text-break cursor-pointer primary-small mr-1 mt-1 text-white fnt-size10px position-relative" (click)="$event.preventDefault();$event.stopPropagation();generateTagMeta(tagUser)">
          @{{tagUser.fullName}}
          <app-meta-generator *ngIf="currentTag=== tagUser" [isMetaState]="isTagMeta" (clickedOutSide)="restoreView()" [isTagMetaGenerated]="true" [seeMore]="currentTag"
          (emitOnMeta)="onMeta($event)"></app-meta-generator>
        </span>
      </p>
    </div>
  </div>  
</div>